export default {"src":"/_next/static/media/sound.b77b39b5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};